import { InjectionToken } from '@angular/core';

/**
 * Default `date_order` for the billing charges list endpoints
 * (`setup`/`service`/`subscription`). The backend defaults to `desc`
 * (newest first) — matched by this token's factory so `apps/web` is
 * correct even without an explicit provider. `apps/admin` overrides to
 * `asc` in its `app.config.ts` (older-first is the admin convention).
 *
 * A per-request override still wins: a component can pass
 * `store.load({ date_order: 'asc', ... })` and the token is untouched.
 */
export const BILLING_CHARGES_DEFAULT_ORDERING = new InjectionToken<
  'asc' | 'desc'
>('billing charges default date_order', {
  providedIn: 'root',
  factory: () => 'desc',
});
